import { useState } from "react";
import { categories, trendingPosts } from "@/mocks/homeContent";

export default function Trending() {
  const tabs = ["全部", ...categories.map((c) => c.label)];
  const [active, setActive] = useState("全部");
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const list =
    active === "全部" ? trendingPosts : trendingPosts.filter((p) => p.cat === active);

  const toggleLike = (id: number) =>
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));

  return (
    <section id="hot" className="scroll-mt-16 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
              正在热议
            </p>
            <h2 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
              今日热帖
            </h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              这些真实的小日常，最近在校园里传得最热闹。
            </p>
          </div>
          <a
            href="#submit"
            className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 px-5 py-2.5 text-sm text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            <i className="ri-add-line" aria-hidden="true" />
            也有故事想分享
          </a>
        </div>

        <div className="mt-7 flex flex-wrap gap-2" role="tablist" aria-label="按栏目筛选热帖">
          {tabs.map((tab) => {
            const activeTab = active === tab;
            return (
              <button
                key={tab}
                type="button"
                role="tab"
                aria-selected={activeTab}
                onClick={() => setActive(tab)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  activeTab
                    ? "bg-primary-500 font-medium text-background-50"
                    : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {tab}
              </button>
            );
          })}
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((post) => {
            const isLiked = liked[post.id];
            return (
              <article
                key={post.id}
                className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between gap-3">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-2xl">
                    {post.emoji}
                  </span>
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                    {post.cat}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-lg leading-snug font-semibold text-foreground-950">
                  {post.title}
                </h3>
                <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {post.excerpt}
                </p>

                <div className="mt-4 flex flex-wrap gap-2">
                  {post.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-md bg-background-100 px-2 py-0.5 text-xs text-foreground-600"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>

                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span className="truncate">
                    <i className="ri-user-heart-line mr-1" aria-hidden="true" />
                    {post.author} · {post.time}
                  </span>
                  <div className="flex shrink-0 items-center gap-3">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line" aria-hidden="true" />
                      {post.view}
                    </span>
                    <button
                      type="button"
                      aria-pressed={isLiked}
                      aria-label={isLiked ? "取消点赞" : "点赞"}
                      onClick={() => toggleLike(post.id)}
                      className={`flex items-center gap-1 rounded-full px-2.5 py-1 transition-colors ${
                        isLiked
                          ? "bg-primary-100 font-medium text-primary-700"
                          : "hover:bg-secondary-100 hover:text-primary-700"
                      }`}
                    >
                      <i
                        className={isLiked ? "ri-heart-3-fill" : "ri-heart-3-line"}
                        aria-hidden="true"
                      />
                      {isLiked ? post.like + 1 : post.like}
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}